export default {
    add: 'Create new',
    empty: {
        title: 'No print templates yet',
        subtitle: 'Add a template to customise your printouts.'
    },
    title: 'Print templates',
    subtitle: 'View and edit your print templates',
    limit: 'You can create up to 10 print templates',
    default: 'Default template',
    system: 'System template',
    name: 'Template name',
    defaultLabel: 'Default',
    markAsDefault: 'Mark as default',
    modalTitle: 'Are you sure you want to mark this as your default?',
    modalBody: 'This template will be the preselected one in the print window!',
    copyTemplate: 'Copy',
    copyName: 'Copy of {name}',
    copyConfirmTitle: 'Copy this template?',
    copyConfirmBody: 'A new template will be created with the same settings. You can rename it after.',
    edit: {
        title: 'Edit template',
        subtitle: 'Edit your print template',
        headerColor: 'Header color',
        daysColor: 'Day color',
        tableStripes: 'Table stripes',
        tableBorders: 'Table borders',
        background: 'Background',
        text: 'Text',
        info: 'Information',
        meals: 'Meals',
        days: 'Days (or options)',
        foods: 'Foods',
        categoryColors: 'Color foods based on their category',
        stripes: {
            none: 'Without stripes',
            columns: 'Columns',
            rows: 'Rows',
            mix: 'Mixed'
        },
        daySize: 'Days size',
        foodSize: 'Foods size',
        letterSpacing: 'Letter spacing',
        mealSize: 'Meals size',
        fontFamily: 'Font family',
        orientation: 'Print orientation',
        landscape: 'Landscape',
        portrait: 'Portrait',
        settings: {
            title: 'General settings',
            template: 'Print template',
            showName: 'Show your name',
            showDate: 'Show date',
            showNotes: 'Show notes (on a new page)',
            showLogo: 'Show logo',
            reverseHeaders: 'Reverse days / meals',
            showPlanName: 'Show plan name',
            dietPlans: {
                title: 'Diet plan',
                onePerPage: 'Show one day per page',
                showQuantity: 'Show food quantities',
                showAnalysis: 'Show plan analysis',
                showExercises: 'Show weekly exercise',
                showRecipes: 'Recipes',
                includeRecipes: 'Include recipes in print',
                selectRecipes: 'Select recipes to include',
                selectAll: 'Select all',
                deselectAll: 'Deselect all',
            },
            shoppingList: {
                title: 'Shopping List',
                show: 'Print the shopping list',
                showRecipes: 'Print recipes in the plan',
                showNotForgetList: 'Print the "do not forget" list',
                showFoodQuantities: 'Show food quantities',
                mergeFoods: 'Merge foods (ignores edited names)'
            },
        },
        translation: {
            titles: 'Titles',
            name: 'Plan name',
            date: 'Date',
            dietitian: 'Dietitian',
            days: 'Day names',
            meals: 'Meal names',
            others: 'Other text',
            shoppingList: 'Shopping list',
            dontForget: 'Do not forget the ingredients for the recipes...',
            doNotForget: 'Do not forget...',
            energy: 'Energy',
            carbs: 'Carbohydrates',
            proteins: 'Proteins',
            fats: 'Fats',
            fresh: 'Fresh',
            amylouxes: 'Αμυλούχες',
            animal: 'Animal-based',
            complex: 'Σύνθετα',
            stats: 'Food Statistics'
        },
        header: {
            title: 'Header',
            logoPosition: 'Logo position',
            left: 'Left',
            right: 'Right',
            logoWidth: 'Logo width',
            logoHeight: 'Logo height',
            logo: 'Logo',
            cropLogo: 'Crop Logo',
            applyCrop: 'Apply Crop',
            usingCustomLogo: 'Using custom logo',
            usingDefaultLogo: 'Using default logo',
            uploadLogo: 'Upload Logo',
            uploadCustom: 'Upload Custom',
            replaceLogo: 'Replace',
            borderRadius: 'Rounded corners',
            fontSize: 'Font size',
            textWhenLogoLeft: 'When logo is left, text',
            textNextToLogo: 'Next to logo',
            textRightAligned: 'Right-aligned',
        },
        tabs:{
            header: 'Header',
            colors: 'Colors',
            table: 'Table',
            text: 'Text sizes',
            settings: 'Settings',
            translation: 'Translation'
        }
    }



}